export default {
    indexMessages:  { method: 'get',    url: 'messages' },
    createMessage:  { method: 'post',   url: 'messages'},
    updateMessage:  { method: 'put',    url: 'messages/{id}'},
    destroyMessage: { method: 'delete', url: 'messages/{id}'},
}